import { useTranslation } from "@sagot/i18n";
import { Chip } from "@sagot/ui";
import { clock, waitedSince, type QueueOrderEntry } from "./queue-sort";

interface Props {
  entry: QueueOrderEntry;
  fetchedAt: number;
  now: number;
}

/** How long a chat has been waiting for a person and why it sits where it does: the score, or "always first" for a required handover. */
export function QueueWaitChip({ entry, fetchedAt, now }: Props) {
  const { t } = useTranslation();
  const hint = entry.rg ? t("routingLive.queue.inbox.firstHint") : t("routingLive.queue.inbox.scoreHint", { score: entry.score });
  return (
    <Chip tone={entry.rg ? "danger" : "muted"} icon={entry.rg ? "shield-alert" : "hourglass"} title={hint} data-testid="queue-wait">
      {t("routingLive.queue.inbox.waiting", { time: clock(waitedSince(entry, fetchedAt, now)) })}
    </Chip>
  );
}
